<template>
    <div class="loading-container">
        <div v-html="logo"
             class="pulse">

        </div>
    </div>
</template>
<script lang="ts">
import { defineComponent, ref } from "vue";

import { IdentityData } from "~concierge/types/IdentityTypes";
import { useIdentityStore } from '~concierge/store/identityStore';

export default defineComponent({
    setup() {
        const identity = ref<IdentityData | null>(null);
        const identityStore = useIdentityStore();
        identity.value = identityStore.identity
        const logo = identity.value?.logoUrl
        return {
            logo,
        };
    },
});
</script>
<style lang="scss">
.loading-container {
    width: 100%;
    padding: 0.5em;
    display: flex;
    place-content: center;
    place-items: center;
    height: 9em;
}

.pulse {
    text-align: center;
}

.pulse svg {
    width: clamp(50px, 50%, 50vw);
    fill: var(--loading-color, var(--dealer-primary-color));
    animation: pulse 1.2s infinite;
    transform: perspective(164px) translateZ(0px);
}

@keyframes pulse {
    to {
        transform: perspective(164px) translateZ(88px);
        opacity: 0;
    }
}
</style>
